import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  isNullOrUndefined,
  isNullUndefinedEmptyOrWhiteSpace
} from '@tmhcc/util';
import { AllowedRoute } from 'libs/artisan-edge/src/lib/shared/page-step-nav/page-header-navigation/page-header-navigation-def';
import { AgentInfo } from 'libs/models/def/agent-info';
import { PortalAccess } from 'libs/models/def/portal-access';
import { BehaviorSubject } from 'rxjs';
import { LoginMFARes } from '.';

@Injectable({
  providedIn: 'root'
})
export class GlobalVariablesService {
  protected _browserRefreshed = false;
  constructor(private router: Router) {}

  errorHeader = 'Global Variable: ';

  allSteps = {
    'General Liability': {
      '/ucm-forms/gl-insured': true,
      '/ucm-forms/gl-owner': false,
      '/ucm-forms/gl-ratings': false,
      '/ucm-forms/gl-liability': false,
      '/ucm-forms/gl-excesscoverage': false,
      '/ucm-forms/gl-property': false,
      '/ucm-forms/gl-generalquestion': false,
      '/ucm-forms/gl-coveragequestion': false,
      '/general/underwriting/documents': false,
      '/ucm-forms/gl-renewalreview': false,
      '/general/pending-review/policysnapshot': false,
      '/general/pending-review/verifycoverage': false,
      '/general/pending-review/verifypolicy': false,
      '/general/verify-purchase/actionitems': false,
      '/general/verify-purchase/coverages': false,
      '/general/verify-purchase/policy': false
    },
    'Pollution Liability': {
      '/pl-ucm-forms/pl-insured': true,
      '/pl-ucm-forms/pl-owner': false,
      '/pl-ucm-forms/pl-ratings': false,
      '/pl-ucm-forms/pl-liability': false,
      '/pl-ucm-forms/pl-excesscoverage': false,
      '/pl-ucm-forms/pl-property': false,
      '/pl-ucm-forms/pl-generalquestion': false,
      '/pl-ucm-forms/pl-coveragequestion': false,
      '/pollution/underwriting/documents': false,
      '/pl-ucm-forms/pl-renewalreview': false,
      '/pollution/pending-review/policysnapshot': false,
      '/pollution/pending-review/verifycoverage': false,
      '/pollution/pending-review/verifypolicy': false,
      '/pollution/verify-purchase/actionitems': false,
      '/pollution/verify-purchase/coverages': false,
      '/pollution/verify-purchase/policy': false
    },
    'Professional Liability': {
      '/pr-ucm-forms/pr-insured': true,
      '/pr-ucm-forms/pr-owner': false,
      '/pr-ucm-forms/pr-ratings': false,
      '/pr-ucm-forms/pr-liability': false,
      '/pr-ucm-forms/pr-excesscoverage': false,
      '/pr-ucm-forms/pr-property': false,
      '/pr-ucm-forms/pr-generalquestion': false,
      '/pr-ucm-forms/pr-coveragequestion': false,
      '/professional/underwriting/documents': false,
      '/pr-ucm-forms/pr-renewalreview': false,
      '/professional/pending-review/policysnapshot': false,
      '/professional/pending-review/verifycoverage': false,
      '/professional/pending-review/verifypolicy': false,
      '/professional/verify-purchase/actionitems': false,
      '/professional/verify-purchase/coverages': false,
      '/professional/verify-purchase/policy': false
    },
    "Builders' Risk": {
      '/br-ucm-forms/br-insured': true,
      '/br-ucm-forms/br-owner': false,
      '/br-ucm-forms/br-jobsite': false,
      '/br-ucm-forms/br-liability': false,
      '/br-ucm-forms/br-additionalinfo': false,
      '/br-ucm-forms/br-generalquestion': false,
      '/builders/underwriting/documents': false,
      '/br-ucm-forms/br-renewalreview': false,
      '/builders/pending-review/policysnapshot': false,
      '/builders/pending-review/verifycoverage': false,
      '/builders/pending-review/verifypolicy': false,
      '/builders/verify-purchase/actionitems': false,
      '/builders/verify-purchase/coverages': false,
      '/builders/verify-purchase/policy': false
    },
    'Excess Liability': {
      '/ex-ucm-forms/ex-insured': true,
      '/ex-ucm-forms/ex-owner': false,
      '/ex-ucm-forms/ex-ratings': false,
      '/ex-ucm-forms/ex-liability': false,
      '/ex-ucm-forms/ex-automobile': false,
      '/ex-ucm-forms/ex-employeebenefits': false,
      '/ex-ucm-forms/ex-employersliability': false,
      '/ex-ucm-forms/ex-generalquestion': false,
      '/ex-ucm-forms/ex-coveragequestion': false,
      '/excess/underwriting/documents': false,
      '/ex-ucm-forms/ex-renewalreview': false,
      '/excess/pending-review/policysnapshot': false,
      '/excess/pending-review/verifycoverage': false,
      '/excess/pending-review/verifypolicy': false,
      '/excess/verify-purchase/actionitems': false,
      '/excess/verify-purchase/coverages': false,
      '/excess/verify-purchase/policy': false
    },
    "Contractors' Equipment": {
      '/ce-ucm-forms/ce-insured': true,
      '/ce-ucm-forms/ce-owner': false,
      '/ce-ucm-forms/ce-equipment': false,
      '/ce-ucm-forms/ce-liability': false,
      '/contractors/coverages/losspayee': false,
      '/contractors/underwriting/documents': false,
      '/ce-ucm-forms/ce-generalquestion': false,
      '/contractors/pending-review/policysnapshot': false,
      '/contractors/pending-review/verifycoverage': false,
      '/contractors/pending-review/verifypolicy': false,
      '/contractors/verify-purchase/actionitems': false,
      '/contractors/verify-purchase/coverages': false,
      '/contractors/verify-purchase/policy': false
    },
    'Address Change': {
      '/ac-ucm-forms/ac-editaddress': true,
      '/ac-ucm-forms/ac-reviewsubmit': false,
      '/ac-ucm-forms/br-jobsite': false,
      '/ac-ucm-forms/br-liability': false,
      '/ac-ucm-forms/br-additionalinfo': false,
      '/ac-ucm-forms/br-generalquestion': false,
      '/addresschange/underwriting/documents': false,
      '/ucm-forms/br-renewalreview': false,
      '/addresschange/pending-review/policysnapshot': false,
      '/addresschange/pending-review/verifycoverage': false,
      '/addresschange/pending-review/verifypolicy': false,
      '/addresschange/verify-purchase/actionitems': false,
      '/addresschange/verify-purchase/coverages': false,
      '/addresschange/verify-purchase/policy': false
    }
  };

  updateStep = new BehaviorSubject(this.allSteps[this.productName]);

  enableStep(step: string) {
    if (this.allSteps[this.productName][step] === false) {
      this.allSteps[this.productName][step] = true;
      this.updateStep.next(this.allSteps[this.productName]);
    }
  }

  resetSteps() {
    for (let pro in this.allSteps) {
      for (let step in this.allSteps[pro]) {
        this.allSteps[pro][step] = false;
      }
    }
  }

  public get browserRefreshed() {
    return this._browserRefreshed;
  }

  public set oldPolicyStatus(policyStatus: string) {
    sessionStorage.oldPolicyStatus = policyStatus;
  }

  public get oldPolicyStatus() {
    return sessionStorage.oldPolicyStatus;
  }

  public set browserRefreshed(flag: boolean) {
    this._browserRefreshed = flag;
  }

  public get agencyId() {
    let userData = JSON.parse(sessionStorage.userDetails);
    return userData.AgencyInfo.ContactId;
  }
  public get agentId() {
    let userData = JSON.parse(sessionStorage.userDetails);
    return userData.AgentInfo.ContactId;
  }

  public get agentInfo(): AgentInfo {
    if (isNullOrUndefined(sessionStorage.userDetails)) return null;

    const userDetails = JSON.parse(sessionStorage.userDetails);

    if (
      isNullOrUndefined(userDetails) ||
      isNullOrUndefined(userDetails.AgentInfo)
    )
      return null;

    return userDetails.AgentInfo as AgentInfo;
  }

  public get portalAccess(): PortalAccess[] {
    if (isNullOrUndefined(sessionStorage.userDetails)) return null;

    const userDetails = JSON.parse(sessionStorage.userDetails);

    if (
      isNullOrUndefined(userDetails) ||
      isNullOrUndefined(userDetails.PortalAccess)
    )
      return null;

    return userDetails.PortalAccess as PortalAccess[];
  }

  public get policyNum() {
    return sessionStorage.policyNum || this.nevigateToDashboard;
  }

  public set policyNum(policyNum: string) {
    if (isNullUndefinedEmptyOrWhiteSpace(policyNum)) {
      throw new Error(this.errorHeader + 'policyNum is invalid');
    }
    sessionStorage.policyNum = policyNum;
  }

  public get policyTypeId() {
    return sessionStorage.policyTypeId || this.nevigateToDashboard;
  }

  public set policyTypeId(policyTypeId: number) {
    if (policyTypeId <= 0) {
      throw new Error(this.errorHeader + 'policyTypeId is invalid');
    }
    sessionStorage.policyTypeId = policyTypeId;
  }

  public get subCompanyCode() {
    return sessionStorage.subCompanyCode || this.nevigateToDashboard;
  }

  public set subCompanyCode(subCompanyCode: string) {
    if (!subCompanyCode) {
      throw new Error(this.errorHeader + 'subCompanyCode is invalid');
    }
    sessionStorage.subCompanyCode = subCompanyCode;
  }

  public get policyId() {
    return sessionStorage.policyId || this.nevigateToDashboard;
  }

  public set policyId(policyId: number) {
    sessionStorage.policyId = policyId;
  }

  public get policyTxnId() {
    return sessionStorage.policyTxnId || this.nevigateToDashboard;
  }

  public set policyTxnId(policyTxnId: number) {
    sessionStorage.policyTxnId = policyTxnId;
  }

  public get policyTxnNum() {
    return sessionStorage.policyTxnNum || this.nevigateToDashboard;
  }

  public set policyTxnNum(policyTxnNum: number) {
    sessionStorage.policyTxnNum = policyTxnNum;
  }

  public get policyVersionId() {
    return sessionStorage.policyVersionId || this.nevigateToDashboard;
  }

  public set policyVersionId(policyVersionId: number) {
    sessionStorage.policyVersionId = policyVersionId;
  }

  public get showSubmitButton() {
    return sessionStorage.showSubmitButton || this.nevigateToDashboard;
  }

  public set showSubmitButton(showSubmitButton: boolean) {
    sessionStorage.showSubmitButton = showSubmitButton;
  }

  public get stepsNavigation() {
    return sessionStorage.updateSteps;
  }

  public set stepsNavigation(updateSteps: any) {
    sessionStorage.updateSteps = updateSteps;
  }

  public get productName() {
    return sessionStorage.productName;
  }

  public set productName(productName: string) {
    sessionStorage.productName = productName;
  }

  public get isSummaryEnable() {
    return sessionStorage.isSummaryEnable;
  }

  public set isSummaryEnable(summaryFlag: string) {
    sessionStorage.isSummaryEnable = summaryFlag;
  }

  public get nevigateToDashboard() {
    //this.router.navigate([AllowedRoute.Dashboard]);
    return 0;
  }

  public get policyStatus() {
    return sessionStorage.policyStatus;
  }

  public set policyStatus(pendingReviewFlag: string) {
    sessionStorage.policyStatus = pendingReviewFlag;
  }

  public get loggedInUser() {
    let userLoginInfo = JSON.parse(sessionStorage.userDetails);
    return `Agent: ${userLoginInfo.AgentInfo.Name} (${userLoginInfo.AgentInfo.ContactId})`;
  }

  public get sessionId() {
    return sessionStorage.sessionId;
  }

  public set sessionId(sessionId: string) {
    sessionStorage.sessionId = sessionId;
  }

  public get performPolicyTypeValidation() {
    return sessionStorage.performPolicyTypeValidation;
  }
  public set performPolicyTypeValidation(performPolicyTypeValidation: boolean) {
    sessionStorage.performPolicyTypeValidation = performPolicyTypeValidation;
  }

  public get gaTrackingId() {
    return sessionStorage.gaTrackingId;
  }
  public set gaTrackingId(gaTrackingId: string) {
    sessionStorage.gaTrackingId = gaTrackingId;
  }

  public get loginMFAInfo(): LoginMFARes {
    if (isNullOrUndefined(sessionStorage.userInfo)) return null;

    const userinfo = JSON.parse(sessionStorage.userInfo);

    if (isNullOrUndefined(userinfo) || isNullOrUndefined(userinfo.OktaId))
      return null;

    return userinfo as LoginMFARes;
  }
  public set loginMFAInfo(userInfo: LoginMFARes) {
    sessionStorage.userInfo = JSON.stringify(userInfo);
  }

  public set cachedState(cachedState: boolean) {
    sessionStorage.cachedState = cachedState;
  }

  public get cachedState() {
    return sessionStorage.cachedState;
  }

  public get  additionalInsuredFormType() {
    return sessionStorage.additionalInsuredFormType;
  }

  public set additionalInsuredFormType(additionalInsuredFormType: string) {    
    sessionStorage.additionalInsuredFormType = additionalInsuredFormType;
  }
  public get isWrittenCommissionDisplayApplicable() {
    return sessionStorage.isWrittenCommissionDisplayApplicable;
  }
  public set isWrittenCommissionDisplayApplicable(isWrittenCommissionDisplayApplicable: string) {
     sessionStorage.isWrittenCommissionDisplayApplicable=isWrittenCommissionDisplayApplicable;
  }

  public get  insuredContactId() {
    return sessionStorage.insuredContactId;
  }

  public set insuredContactId(insuredContactId: number) {    
    sessionStorage.insuredContactId = insuredContactId;
  }

  resetGlobalVariableCache(resetSteps = true) {
    sessionStorage.subCompanyCode = '';
    sessionStorage.policyId = 0;
    sessionStorage.policyVersionId = 0;
    sessionStorage.policyTxnId = 0;
    sessionStorage.policyTxnNum = 0;
    sessionStorage.policyNum = '';
    sessionStorage.showSubmitButton = false;
    sessionStorage.updateSteps = '';
    sessionStorage.performPolicyTypeValidation = false;
    sessionStorage.policyStatus = '';
    sessionStorage.insuredContactId=0;
    sessionStorage.additionalInsuredFormType='';
    if (resetSteps) {
      this.resetSteps();
    }
  }

  toBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  stateCodeList = [
    { StateCode: 'AL', StateName: 'Alabama' },
    { StateCode: 'AK', StateName: 'Alaska' },
    { StateCode: 'AZ', StateName: 'Arizona' },
    { StateCode: 'AR', StateName: 'Arkansas' },
    { StateCode: 'CA', StateName: 'California' },
    { StateCode: 'CO', StateName: 'Colorado' },
    { StateCode: 'CT', StateName: 'Connecticut' },
    { StateCode: 'DE', StateName: 'Delaware' },
    { StateCode: 'FL', StateName: 'Florida' },
    { StateCode: 'GA', StateName: 'Georgia' },
    { StateCode: 'HI', StateName: 'Hawaii' },
    { StateCode: 'ID', StateName: 'Idaho' },
    { StateCode: 'IL', StateName: 'Illinois' },
    { StateCode: 'IN', StateName: 'Indiana' },
    { StateCode: 'IA', StateName: 'Iowa' },
    { StateCode: 'KS', StateName: 'Kansas' },
    { StateCode: 'KY', StateName: 'Kentucky' },
    { StateCode: 'LA', StateName: 'Louisiana' },
    { StateCode: 'ME', StateName: 'Maine' },
    { StateCode: 'MD', StateName: 'Maryland' },
    { StateCode: 'MA', StateName: 'Massachusetts' },
    { StateCode: 'MI', StateName: 'Michigan' },
    { StateCode: 'MN', StateName: 'Minnesota' },
    { StateCode: 'MS', StateName: 'Mississippi' },
    { StateCode: 'MO', StateName: 'Missouri' },
    { StateCode: 'MT', StateName: 'Montana' },
    { StateCode: 'NE', StateName: 'Nebraska' },
    { StateCode: 'NV', StateName: 'Nevada' },
    { StateCode: 'NH', StateName: 'New Hampshire' },
    { StateCode: 'NJ', StateName: 'New Jersey' },
    { StateCode: 'NM', StateName: 'New Mexico' },
    { StateCode: 'NY', StateName: 'New York' },
    { StateCode: 'NC', StateName: 'North Carolina' },
    { StateCode: 'ND', StateName: 'North Dakota' },
    { StateCode: 'OH', StateName: 'Ohio' },
    { StateCode: 'OK', StateName: 'Oklahoma' },
    { StateCode: 'OR', StateName: 'Oregon' },
    { StateCode: 'PA', StateName: 'Pennsylvania' },
    { StateCode: 'RI', StateName: 'Rhode Island' },
    { StateCode: 'SC', StateName: 'South Carolina' },
    { StateCode: 'SD', StateName: 'South Dakota' },
    { StateCode: 'TN', StateName: 'Tennessee' },
    { StateCode: 'TX', StateName: 'Texas' },
    { StateCode: 'UT', StateName: 'Utah' },
    { StateCode: 'VT', StateName: 'Vermont' },
    { StateCode: 'VA', StateName: 'Virginia' },
    { StateCode: 'WA', StateName: 'Washington' },
    { StateCode: 'WV', StateName: 'West Virginia' },
    { StateCode: 'WI', StateName: 'Wisconsin' },
    { StateCode: 'WY', StateName: 'Wyoming' }
  ];
}
